import React from "react";
import styles from './GraduationProfile.module.scss';
import PropTypes from "prop-types";
import ProfilePicture from "../profilePicture/ProfilePicture";

const GraduationProfile = ({ overview = {}, programDetails = [] }) => {
  const student = overview?.student || {};
  const cumulativeScore = overview?.cumulativeScore || '0';
  const minimumScore = overview?.minimumScore || '0';
  const programName = programDetails?.length > 0
    ? programDetails.map(p => p.title).join(', ')
    : '—';

  return (
    <div className={styles.graduationProfile}>
      <div className={styles.profileWrapper}>
        <ProfilePicture
          profilePicture={student?.profilePicture}
          firstName={student?.firstName || ""}
          lastName={student?.lastName || ""}
          size="sm"
        />
        <div className={styles.profileInfo}>
          <h3>{student?.firstName} {student?.lastName}</h3>
          <p>Student</p>
        </div>
      </div>
      <div className={styles.profileSection}>
        <div className={styles.graduationDetails}>
          <div className={styles.detailItem}>
            <div className={styles.detailLabel}>Current Year</div>
            <div className={styles.detailValue}>{student?.year?.year}</div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.detailLabel}>Current Semester</div>
            <div className={styles.detailValue}>{student?.semester?.semester}</div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.detailLabel}>Expected Graduation</div>
            <div className={styles.detailValue}>{student?.expectedGraduationDate}</div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.detailLabel}>Cumulative Score</div>
            <div className={`${styles.detailValue} ${styles.scoreHighlight}`}>{cumulativeScore}</div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.detailLabel}>Minimum Requirement</div>
            <div className={styles.detailValue}>{minimumScore}</div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.detailLabel}>Program</div>
            <div className={styles.detailValue}>{programName}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

GraduationProfile.propTypes = {
  overview: PropTypes.shape({
    student: PropTypes.shape({
      profilePicture: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      year: PropTypes.shape({
        year: PropTypes.string,
      }),
      semester: PropTypes.shape({
        semester: PropTypes.string,
      }),
      expectedGraduationDate: PropTypes.string,
    }),
    cumulativeScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minimumScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  programDetails: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
  })),
};

export default GraduationProfile;
